import { SaveServidor } from "../../components";
export default function CreateServidorPage() {
  return <SaveServidor titulo="Crear Servidor" />;
}